import type { CandidateDto } from '../candidate.dto';

export type Volunteering = {
  role: string | undefined;
  companyName: string | undefined;
  startDate: { month: number | undefined; year: number | undefined };
  endDate: { month: number | undefined; year: number | undefined };
  startEpochTimeInMonths: number | undefined;
  endEpochTimeInMonths: number | undefined;
  description: string | undefined;
};

export const toVolunteering = (dto: CandidateDto): Volunteering[] => {
  return (dto._source.experiences.volunteer || [])?.map<Volunteering>((job) => ({
    role: job.role,
    companyName: job.company?.name,
    startDate: {
      month: job.dates?.start?.month,
      year: job.dates?.start?.year,
    },
    endDate: {
      month: job.dates?.end?.month,
      year: job.dates?.end?.year,
    },
    startEpochTimeInMonths: job.dates?.start_recalculated,
    endEpochTimeInMonths: job.dates?.end_recalculated,
    description: job.description ?? undefined,
  }));
};
